import icon from 'assets/img/icons/icon-warning.svg'

const RedeemPrizeFail = ({close}) => {
  return (
    <>
    <header className="modal-window__header">
      <img src={icon} className="modal-window__icon" alt="" />
      <h5 className="modal-window__title">Redeeming Declined!</h5>
      <p className="modal-window__info">Redeeming prize was not completed.</p>
    </header>
    <footer className="modal-window__footer">
      <button className="modal-window__footer-close" onClick={close}>Done</button>
    </footer>
  </>
  )
}

export default RedeemPrizeFail;
